export default "__VITE_ASSET__CSndkzP$__"